import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-result-container" }

import { ref, onMounted } from 'vue';
import { userStore } from "@/store/userStore";
import loginAPI from "@/api/loginAPI";
import { useRoute } from 'vue-router'; // useRoute 함수 import

export default /*@__PURE__*/_defineComponent({
  __name: 'checkplus_success',
  setup(__props) {

const store = userStore();

// 라우트 객체 가져오기
const route = useRoute();

const testData = ref({})

// 컴포넌트 마운트 시 본인인증 데이터 가져오기
onMounted(() => {
  // 모든 쿼리 파라미터 출력
  
  loginAPI.tokenCallback(route.query).then((res) => {
    testData.value = res.data
    
    const safeData = JSON.stringify(res.data);
    window.opener.postMessage({
      type: 'AUTH_LOGIN_SUCCESS',
      data: safeData
    }, window.location.origin); // 보안을 위해 동일 origin으로 제한
    
    // 잠시 후 창 닫기
    setTimeout(() => window.close(), 0);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})